// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/special-vfr.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/special-vfr/special-vfr-pilot-judgement.js';
import g1 from '../lessons/air-law/special-vfr/special-vfr.js';

mount([g0, g1]);
